<template>
  <div
    class="tool-tip caption"
    :class="{
      'tool-tip--size-auto': size === 'auto'
    }"
    :style="{
      display: display,
      top: `${position.y}px`,
      left: `${position.x}px`,
    }"
    :aria-hidden="!visible"
  >
    {{ label }}
  </div>
</template>

<script>

/**
 * Vue: Tool Tip (tool-tip)
 * -----------------------------------------------------------------------------
 * Tool Tips.
 * @param {String} label - Tooltip content
 * @param {String} target - $refs target for associated tooltip
 * @param {Boolean} visible - Boolean to determine visibility of tooltip
 * @param {String} size - Optional key to influence the size of the tooltip
 *
 */
export default {
  name: 'ToolTip',

  props: {
    label: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    size: {
      type: String,
      default: 'auto',
    },
  },

  data() {
    return {
      display: 'initial',
      position: {
        y: 0,
        x: 0,
      },
      targetData: {},
      tooltipData: {},
    }
  },

  watch: {

    /**
     * Watch tooltip visibility
     */
    visible() {
      this.setProperties()
    },
  },

  mounted() {
    this.init()
  },

  methods: {

    /**
     * Init tooltip properties
     */
    init() {
      this.tooltipEl = this.$el
      this.targetEl = this.$parent.$refs[this.target].$el
      this.tooltipData = this.tooltipEl.getBoundingClientRect()
      this.display = 'none'
    },

    /**
     * Set tooltip visibility and position
     */
    setProperties() {
      if (!this.visible) {
        this.display = 'none'
        return
      }

      this.targetData = this.targetEl.getBoundingClientRect()

      let xCoord = this.targetData.xCoord

      if (this.targetData.width > this.tooltipData.width) {
        xCoord = ((this.targetData.width - this.tooltipData.width) / 2) + this.targetData.x

      } else if (this.targetData.width < this.tooltipData.width) {
        xCoord = this.targetData.x - ((this.tooltipData.width - this.targetData.width) / 2)
      }

      this.position.y = this.targetData.bottom
      this.position.x = xCoord
      this.display = 'block'
    },
  },
}
</script>

<style lang="scss">
@import './tool-tip';
</style>
